export const FETCH_ALLOCATED_PAYMENT_INVOICELIST_REQUEST = "FETCH_ALLOCATED_PAYMENT_INVOICELIST_REQUEST";
export const FETCH_ALLOCATED_PAYMENT_INVOICELIST_SUCCESS = "FETCH_ALLOCATED_PAYMENT_INVOICELIST_SUCCESS";
export const FETCH_ALLOCATED_PAYMENT_INVOICELIST_FAILURE = "FETCH_ALLOCATED_PAYMENT_INVOICELIST_FAILURE";
